import { ApiBase } from "../base/api-base";
import { ApiConstants } from "../common/apiConstants";
const idTienda_ = ApiConstants.ID_TIENDA;

export class ProductService extends ApiBase {
  //Obtener los catalogos
  async getCatalogs() {
    return await this.get("Tienda/ObtenerCatalogos?IdTienda=" + idTienda_);
  }

  async getProduct(id) {
    return await this.get("Producto/GetProductsByIdCatalog?id=" + id);
  }

  /**
   * Busca productos por palabra clave
   * @param keyWord Palabra clave 
   * @param storeId id de la tienda (opcional)
   * @returns Listado de productos
   */
  async getByKeyWord(keyWord, storeId = 0) {
    return await this.get(`Producto/GetByKeyWord?keyWord=${keyWord}&idTinda=${storeId}`);
  }


  /**
   * Obtienen un listado de productos de una tienda
   * @param  id id de la tienda
   * @returns Listado de productos
   */
  async getProductsByStore(storeId, page = 1, size = 10) {
    return await this.get(`Tienda/ProductosPorTienda?IdTienda=${storeId}&pagina=${page}&tamanio=${size}`);
  }

  /**
   * Obtiene los productos de la pagina principal
   * @returns Listado de productos
   */
  async GetProductsMainScreen() {
    return await this.get(`Producto/GetProductsMainScreen`);
  }

  /**
   * Obtienen un listado de productos basado en el id de la tienda y un listado de filtros
   * @param  filters filtros
   * @example { "keyWord": "producto", "idTienda": 2, "opciones": [ { "nombre": "Marca","valor": "Montagas" }] }
   * @returns Listado de productos
   */
  async GetBySpecificFiltersStore(filters) {
    return await this.post(`Producto/GetBySpecificFiltersStore?idTienda=${idTienda_}`, filters);
  }

  /**
   * Obtienen un listado de productos por palabra clave
   * @param  keyWord produto buscado 
   * @returns Listado de productos
   */
  // async getProductsByKeyWord(keyWord) {
  //   return await this.get(`Producto/GetFiltersByKeyWord?keyWord=${keyWord}`);
  // }

  /**
   * Obtiene productos por catalogo o categoria
   * @param id catalogo o categoria
   * @returns Listado de productos
   */
  async getProductsByIdCatalog(id) {
    return await this.get(`Producto/GetProductsByIdCatalog?id=${id}`);
  }

  /**
   * Obtienen un listado de productos basado en el id de la tienda y un listado de filtros
   * @param  filters filtros
   * @example { "keyWord": "producto", "idTienda": 2, "opciones": [ { "nombre": "Marca","valor": "Montagas" }] }
   * @returns Listado de productos
   */
  async GetBySpecificFilters(filters, page = 1, size = 12) {
    return await this.post(`Producto/GetBySpecificFilters?pagina=${1}&tamanio=${size}`, filters);
  }


  /**
 * Obtiene el detalle de productos por nombre
 * @param nombre Nombre del producto a buscar
 * @returns Detalle del producto
 */
async getProductByName(nombre) {
  return await this.get(`Producto/DetalleProductoByNombre?nombre=${encodeURIComponent(nombre)}`);
}
}
